module.exports = __webpack_public_path__ + "img/font_2.5617043b.webp";